// 移动端路由守卫：/mobile/** 的登录分流、用户类型准入与会话准备。PC 守卫逻辑不经过本文件。
import { mobileStore } from '@/store/mobile'
import { useGlobalStore } from '@/store/global'
import { isMobilePath, resolveMobileTarget, isMobileUserDenied } from './mobileGuardUtils'

export { isMobilePath, resolveMobileTarget }

export async function mobileGuard(to, next) {
	// global store 为 setup 风格，token 在实例上自动解包，直接读取即可
	const gs = useGlobalStore()
	const token = gs.token
	const target = resolveMobileTarget(to.path, token)
	if (target !== null && target !== to.path) {
		next(target)
		return
	}
	if (to.path === '/mobile/login') {
		next()
		return
	}
	// 移动端会话准备：用户信息 + 移动端菜单（一次；type 不在白名单时 store 内部跳过菜单）
	const mStore = mobileStore()
	if (token && !mStore.prepared) {
		await mStore.mobilePreparing()
	}
	// 页面级准入：已加载用户信息且 sys_user.TYPE 不在白名单 {1,2} → 转未开放提示页（getLoginUser 返回的 userInfo.type）。
	// 后端登录接口已拦 device=APP 的白名单外类型登录，此处兜住 PC 登录态（token 共用）直达 /mobile/** 的绕行；
	// userInfo 未加载（令牌失效等）不拦截，走原有 401 重新登录路径
	if (token && isMobileUserDenied(gs.userInfo)) {
		if (to.path !== '/mobile/notOpen') {
			next('/mobile/notOpen')
			return
		}
		next()
		return
	}
	// 白名单外用户直达未开放提示页 → 送回首页
	if (to.path === '/mobile/notOpen') {
		next('/mobile/home')
		return
	}
	next()
}
